import { get, index, getPastPRs, reject } from "src/api/payments";

import PastPaymentsHistoryView from "src/modules/payments/components/PastPaymentsHistoryView.vue";

import { approve } from "src/api/payment-request";
const getInitialState = () => {
  return {
    payments: [],
    payment: {},
    counts: {},
    pastPayments: [],
  };
};

export const usePaymentsStore = defineStore("payments", () => {
  let state = reactive(getInitialState());

  const pastPreviewDrawerState = ref({
    edit: false,
    open: false,
    view: false,
  });

  const togglePastPaymentRequestsView = (state = {}) => {
    pastPreviewDrawerState.value = {
      edit: false,
      open: !pastPreviewDrawerState.value.open,
      view: false,
      ...state,
    };

    const { toggleNestedRightDrawer } = useAppStore();

    toggleNestedRightDrawer({
      component: PastPaymentsHistoryView,
      level: unref(pastPreviewDrawerState).level,
      open: unref(pastPreviewDrawerState).open,
      props: unref(pastPreviewDrawerState).props,
    });
  };

  const statuses = ["awaiting_approval", "approved", "initiated", "hold"];

  const totalCount = computed(() => {
    return Object.keys(state.counts)
      .filter((pr) => statuses.includes(pr))
      .reduce((count, status) => +count + +state.counts[status] || 0, 0);
  });

  const getPayment = async (id) => {
    try {
      state.payment = state.payments.find((pr) => pr._id === id);

      const response = await get(id);

      state.payment = {
        ...state.payment,
        ...response.data?.data,
      };

      return state.payment;
    } catch (error) {
      console.error(error);
    }
  };

  const filters = ref({
    status_cd: null,
  });

  const { filter, pagination, params } = usePagination(filters);

  const getPayments = async (options = {}) => {
    try {
      options = unref(options);

      if (options?.filters) {
        filters.value = options?.filters;

        delete options.filters;
      }

      const response = await index({
        params: unref(params),
        ...options,
      });

      state.payments = response.data?.data?.data || [];

      pagination.value.rowsNumber = response.data?.data?.count || 0;

      const status_counts = response.data?.data?.status_counts;

      if (status_counts) {
        state.counts = status_counts;
      }

      return state.paymentApprovals;
    } catch (error) {
      console.error(error);
    }
  };

  const rejectPaymentRequest = async (pr) => {
    try {
      const response = await reject(pr);

      await getPayments();

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const approvePaymentRequest = async (pr) => {
    try {
      const response = await approve(pr);

      await getPayments();

      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const getPastPaymentRequests = async (options = {}) => {
    try {
      const response = await getPastPRs(options);

      state.pastPayments = response?.data?.data?.data;

      return state.pastPayments;
    } catch (error) {
      console.error(error);
    }
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    filter,
    filters,
    pagination,

    togglePastPaymentRequestsView,

    ...toRefs(state),

    totalCount,

    getPayment,
    getPayments,

    approvePaymentRequest,
    rejectPaymentRequest,
    getPastPaymentRequests,

    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePaymentsStore, import.meta.hot));
}
